import "./src/styles/global.css"
const GA_ID = "G-PP0T90GV3G";
const DISABLE_KEY = `ga-disable-${GA_ID}`;
const STORAGE_KEY = "cookie-consent";

export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : null;
    const analyticsGranted = parsed && parsed.analytics_storage === "granted";
    window[DISABLE_KEY] = !analyticsGranted;
  } catch (err) {
    window[DISABLE_KEY] = true;
  }
};
